import React from 'react'
import StyledImage from "../components/styled-image"
import RollingHills from "../components/icons/rolling-hills"
import { kebabCase } from 'lodash'

export default function Profile({ props }) {
  const { heading, content, image } = props
  return (
    <>
      {(heading || content || image) ? <section
        className={`bg-banner-gradient flex md:flex-row relative flex-col items-center py-8 sm:py-0`}
      >
        <RollingHills />

        <div className={`container`}>
          <div className={`relative flex flex-col sm:flex-row sm:gap-6 xl:gap-12 flex-row items-center h-full max-w-5xl mx-auto`}>
            {(image) ?
              <StyledImage
                image={image}
                objectFit="cover"
                objectPosition={"center"}
                className={`w-full flex-grow h-auto max-w-[16rem] sm:max-w-none sm:min-w-[12rem] md:min-w-[16rem] xl:min-w-[20rem] sm:h-full`} />
              : null}
            <div className={`py-6`}>
              {heading ? <div className="mb-2 lg:mb-3">

                {heading ? (
                  <h2 id={kebabCase(heading)} className={`mb-1 leading-normal text-white`}>{heading}</h2>
                ) : null}

              </div> : null}
              {content && (
                <div
                  className={`parsed-content text-white links-light mb-2 lg:mb-3`}
                  dangerouslySetInnerHTML={{
                    __html: content,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section> : null}
    </>
  )
}
